
import { Component, inject, computed, signal } from '@angular/core';
import { NgIf } from '@angular/common';
import { LoaderService } from "./Loader.services";

@Component({
 selector: 'app-loader',
 standalone: true,
 imports: [NgIf],
 template: `
   <div class="loader-overlay" *ngIf="loading()">
     <div class="loader-card">
       <div class="blob">
         <div class="dot d1"></div>
         <div class="dot d2"></div>
         <div class="dot d3"></div>
         <div class="dot d4"></div>
       </div>
       <div class="text">
         <span class="title">Loading</span>
         <span class="sub">Please wait…</span>
       </div>
     </div>
   </div>
 `,
 styles: [`
   :host { position: fixed; inset: 0; pointer-events: none; z-index: 9999; }
   .loader-overlay {
     position: fixed; inset: 0;
     backdrop-filter: blur(6px) saturate(1.1);
     background: rgba(10, 15, 25, 0.25);
     display: grid; place-items: center;
     pointer-events: all;
   }
   .loader-card {
     width: 220px; height: 220px;
     border-radius: 24px;
     background: rgba(255,255,255,0.08);
     box-shadow: 0 10px 30px rgba(0,0,0,0.35);
     border: 1px solid rgba(255,255,255,0.18);
     display: grid; place-items: center;
     position: relative; overflow: hidden;
   }
   .blob {
     width: 120px; height: 120px; border-radius: 50%;
     background:
       radial-gradient(closest-side, rgba(255,255,255,0.35), transparent 70%),
       conic-gradient(from 0deg, #6EE7F9, #93C5FD, #A78BFA, #F472B6, #FDE68A, #6EE7F9);
     animation: spin 2.2s linear infinite, pulse 2.2s ease-in-out infinite alternate;
     position: relative;
     filter: drop-shadow(0 0 8px rgba(255,255,255,0.25));
   }
   @keyframes spin { to { transform: rotate(360deg); } }
   @keyframes pulse { 0% { transform: scale(0.95); } 100% { transform: scale(1.05); } }
   .dot {
     position: absolute; width: 10px; height: 10px; border-radius: 50%;
     background: rgba(255,255,255,0.9);
     box-shadow: 0 0 8px rgba(255,255,255,0.6);
   }
   .d1 { top: -6px; left: 50%; transform: translateX(-50%); animation: orbit 1.8s linear infinite; }
   .d2 { right: -6px; top: 50%; transform: translateY(-50%); animation: orbit 1.8s .15s linear infinite; }
   .d3 { bottom: -6px; left: 50%; transform: translateX(-50%); animation: orbit 1.8s .3s linear infinite; }
   .d4 { left: -6px; top: 50%; transform: translateY(-50%); animation: orbit 1.8s .45s linear infinite; }
   @keyframes orbit {
     0%  { transform: translate(-50%, -50%) rotate(0deg) translateX(66px); }
     100% { transform: translate(-50%, -50%) rotate(360deg) translateX(66px); }
   }
   .text {
     position: absolute; bottom: 18px; width: 100%;
     text-align: center; color: #fff; font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif;
   }
   .title { display: block; font-weight: 600; letter-spacing: 0.3px; }
   .sub { display: block; font-size: 0.82rem; opacity: 0.75; margin-top: 4px; }
 `]
})
export class LoaderComponent {
  private loader = inject(LoaderService);
  //public loading  =this.loader.loading();
loading=signal<boolean>(this.loader.loading());
  //loading = computed(() => this.loader.loading());
}